import { PracticeApi } from "../openapi";
import openApiConfig from "./http_service";

const practiceApi=new PracticeApi(openApiConfig)

export default practiceApi